module.exports = __webpack_public_path__ + "img/credit-one-club-gal-9.0d9fb175.jpg";